import { PracticeInfo } from 'types';
import { Appointment } from 'EntityTypes';
import { formatPhone } from './format';

export const formatPracticeAddress = (practice: PracticeInfo): string => {
  return practice.settings.practiceAddress.replace('\n', ', ');
};

/**
 * Return practice phone from practice object.
 * First, it tries to read the phone from practice settings (online schedule setting).
 * Then it falls back to the phone from practice primary location.
 * If none of these phones is set up, then it returns an empty string.
 */
export const getPracticePhone = (practice: PracticeInfo): string => {
  if (practice.settings?.phone) return formatPhone(practice.settings.phone);
  if (practice.phone) return formatPhone(practice.phone);
  return '';
};

export const getPracticeCancellationPolicy = (practice: PracticeInfo): string => {
  if (practice.settings?.cancellationPolicy) return practice.settings.cancellationPolicy;
  return 'Please check the cancellation policy. You may be charged a fee for canceling this appointment.';
};

/**
 * Return phone from the service location and if that fails then the practice phone will be used.
 */
export const getAppointmentPhone = (appointment: Appointment, practice: PracticeInfo): string => {
  if (appointment.fhirLocation?.phone) return formatPhone(appointment.fhirLocation.phone);
  return getPracticePhone(practice);
};
